import { selectUserState } from "redux/user/selectors/selectUserState";
import { createSelector } from "reselect";

export const selectUserProfile = createSelector([selectUserState], (user) => user.userProfile);
